/* eslint-disable import/prefer-default-export,no-console,arrow-body-style */
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { BatchHttpLink } from "apollo-link-batch-http";
import {HttpLink} from "apollo-link-http";
import { onError } from 'apollo-link-error';
import { setContext } from 'apollo-link-context';
import { ApolloLink } from 'apollo-link';
import { MD5 } from 'crypto-js';
import API from "../config/API";
import {getParameterByName} from "./url";

export const getApolloClient = (authToken, tokenForRefresh, cookies, authContext, fallbackAPIHosts=false) => {

    // eslint-disable-next-line prefer-const
    let authTokenRefreshable = authToken;

    // Determine which API to target
    let apiHost = API.getHost();
    if (fallbackAPIHosts) {
        apiHost = API.getFallbackHost();
    }

    // Use Frontend URL for gql calls
    // if (apiHost === 'https://content.marketaxess.com') {
    //     apiHost = 'https://www.marketaxess.com';
    // }


    const authLink = setContext((_, { headers }) => {
        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
//                Authorization: authTokenRefreshable ? `Basic ${authTokenRefreshable}` : ""
            }
        }
    });

    const httpLinkParams = {
        batchInterval: 20,
        uri: `${apiHost}/graphql`,
        fetch: async (uri, options) => {

            const clearCache = getParameterByName('clear');

            let hashedBody = MD5(options.body).toString();

            // Set Auth header if user logged in
            if (authTokenRefreshable) {
                // eslint-disable-next-line no-param-reassign
 //               options.Authorization = `Basic ${authTokenRefreshable}`;

            }

            const getOptions = Object.assign({}, options);
            getOptions.method = 'GET';
            getOptions.body = null;

            const postOptions = Object.assign({}, options);

            // check if context
            if ((authContext) && (authContext !== '')) {

                getOptions.headers['x-gql-i'] = `${authContext}`;
                postOptions.headers['x-gql-i'] = `${authContext}`;

                // Don't override hash with authenticated hash if main query (get pages, menus, etc) or user info call
                if (hashedBody !== '0c59620e19c4c70f26f7cb6bca81bb80' && hashedBody !== '5544a8fa619c1417d129a3549a05296f') {
                    hashedBody = MD5(hashedBody.concat(authContext)).toString();
                }

            }

            // Clear Cache
            if (clearCache === 'yes-please') {
                getOptions.headers['x-gql-clear'] = hashedBody;
                postOptions.headers['x-gql-clear'] = hashedBody;
                return fetch(`${apiHost}/graphql`, postOptions);
            }

            // with new worker, just call graphql
            return fetch(`${apiHost}/graphql`, postOptions);
/*

            // Don't fetch cached copy of user info
            if (
                hashedBody === '5544a8fa619c1417d129a3549a05296f' || // Production
                hashedBody === '53d3a7e8e8f88e8d2b7e1bc51d738c25' || // Staging
                hashedBody === '47713a5004f7c961bbcb4d55e25cca08' // Dev
            ) {
                return fetch(`${apiHost}/graphql`, postOptions);
            }

            // Check initial page cache if user is not authenticated
            if (!authTokenRefreshable && window.gqlJsonCache && window.gqlJsonCache[hashedBody]) {
                let currentCache = window.gqlJsonCache[hashedBody];
                if (typeof currentCache === 'object') {
                    currentCache = JSON.stringify(currentCache);
                }
                const currentCacheJson = JSON.parse(currentCache);
                if (currentCacheJson && currentCacheJson.status !== false) {
                    return new Response(currentCache, {});
                }
            }

            const cacheCheckUri = `${apiHost}/files/gqlc/6/${hashedBody}.json`;

            const rawCacheResponse = await fetch(cacheCheckUri, getOptions);

            // Clone Fetch promise in order to parse data without modifying object
            const rawCacheResponseClone = await (rawCacheResponse).clone();
            const cacheResponse = await (rawCacheResponseClone).json();

            // Use Cached data if user is not logged in
            if (cacheResponse.status !== false) {

                // Bypass if user is logged in and response is main call (This call runs once after the first login)
                if (authTokenRefreshable && cacheResponse[0] && cacheResponse[0].data && cacheResponse[0].data.currentUserContext && cacheResponse[0].data.currentUserContext.name === '') {
                    return fetch(`${apiHost}/graphql`, postOptions);
                }

                return rawCacheResponse;
            }

            return fetch(uri, options);
*/
        }
    };

    // Paths to exclude from GQL batching (pages that are heavily cached).
    const excludeFromBatch = [
        '/trade/emerging-markets/'
    ];
    const windowPath = window.location.pathname.slice(-1) === '/' ? window.location.pathname : `${window.location.pathname}/`;
    const batchingEnabled = !!authTokenRefreshable && !excludeFromBatch.includes(windowPath);
    const httpLink = batchingEnabled ? new BatchHttpLink(httpLinkParams) : new HttpLink(httpLinkParams);

    // Generate HTTPLink
    const link = authLink.concat(ApolloLink.from([
        onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors)
                graphQLErrors.map(({ message, locations, path }) =>
                    console.log(
                        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
                    ),
                );
            if (networkError) console.log(`[Network error]: ${networkError}`);
        }),
        httpLink
    ]));

    // Initialize Client
    return new ApolloClient({
        link,
        cache: new InMemoryCache(),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'ignore',
            },
            query: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
            }
        }
//        shouldBatch: !excludeFromBatch.includes(window.location.pathname),
//        batchInterval: 1000
    })

};




// WEBPACK FOOTER //
// ./frontend/helpers/apollo.js